import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routing';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AppComponent } from './app.component';
import { AuthService } from './services/auth.service';
import { ErrorsService } from './services/errors.service';
import { ApiService } from './services/api.service';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomeComponent } from './pages/home/home.component';
import { AuthComponent } from './pages/auth/auth.component';
import { CookiesService } from './services/cookies.service';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { MenuComponent } from './layouts/menu/menu.component';
import { CertificatesService } from './services/certificates.service';
import { ArchwizardModule } from 'angular-archwizard';
import { ChangeTermsPurchaseComponent } from './pages/change-terms-purchase/change-terms-purchase.component';
import { ChangeTermsPurchaseRowComponent } from './pages/change-terms-purchase/change-terms-purchase-row.component';
import { BlockComponent } from './pages/block/block.component';
import { XmlService } from './services/xml.service';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    HomeComponent,
    NotFoundComponent,
    MenuComponent,
    ChangeTermsPurchaseComponent,
    ChangeTermsPurchaseRowComponent,
    BlockComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ArchwizardModule,
    ToastModule.forRoot(),
    ReactiveFormsModule,
    ModalModule.forRoot(),
    AccordionModule.forRoot()
  ],
  providers: [
    CookiesService,
    Title,
    ApiService,
    AuthService,
    ErrorsService,
    CertificatesService,
    XmlService,
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts